import { fetchV1, fetchAdminV1 } from "../lib/requester/v1";

export function getAll(params) {
	return fetchV1("/vendor_services", { method: "GET", data: params }, { returnWholeResponse: true });
}

export function getAllForAdmin(params) {
	return fetchAdminV1("/vendor_services", { method: "GET", data: params }, { returnWholeResponse: true });
}

export function getVendorWithUserAnswersForAdmin(id) {
	return fetchAdminV1(`/vendor_services/${id}/user_answers`, { method: "GET" });
}

export function getById(id) {
	return fetchV1(`/vendor_services/${id}`, { method: "GET" });
}

export function create(data) {
	return fetchV1(`/vendor_services`, { method: "POST", data });
}

export function update(data) {
	return fetchV1(`/vendor_services/${data.id}`, { method: "PUT", data });
}

export function remove(id) {
	return fetchV1(`/vendor_services/${id}`, { method: "DELETE" });
}

export function launch(id) {
	return fetchV1(`/vendor_services/${id}/launch`, { method: "GET" }, { returnWholeError: true });
}

export function getActiveVendorServicesWithMatches() {
	return fetchV1("/vendor_services/matches", { method: "GET" });
}

export function getVendorMatches(userId, { page = 1, limit = 10 } = {}) {
	return fetchV1(`/matches/founder-vendor-matches`, { 
		method: "GET",
		data: {
			user_id: userId,
			role: 'vendor',
			page,
			limit
		}
	});
}

export function getFounderMatches(userId, { page = 1, limit = 10 } = {}) {
	return fetchV1(`/matches/founder-vendor-matches?user_id=${userId}&role=founder&page=${page}&limit=${limit}`, { method: "GET" });
}

export function updateFounderVendorMatchStatus(id, { status, call_status }) {
	return fetchV1(`/matches/founder-vendor-matches/${id}/status`, { 
		method: "PUT", 
		data: { status, call_status } 
	});
}

export function getFounderDetailsForVendorMatch(matchId) {
	return fetchV1(`/matches/founder-vendor-matches/${matchId}/founder-details`, { method: "GET" });
}

export function getVendorDetailsForFounderMatch(matchId) {
  return fetchV1(`/matches/founder-vendor-matches/${matchId}/vendor-details`, { method: "GET" });
}
